'use client'

import { NexperienceOpeningHoursDocument } from '@data-access/lib/gql/experience/documents'
import { useGraphQL } from '@data-access/lib/graphql-query'
import { formatIsoDate } from '@utils/utils-format'

export const OPENING_HOURS_STALE_TIME = 5 * 60 * 1000

export function toIsoDate(date: Date): string {
  return formatIsoDate(date)
}

export function useExperienceOpeningHours(
  publicId: number,
  from: string,
  to: string,
  enabled = true,
  previewToken?: string
) {
  const { data, isLoading, isError, refetch } = useGraphQL(
    NexperienceOpeningHoursDocument,
    { locale: 'de', publicId, from, to, previewToken },
    {
      select: response => response.nexperience?.openingHours ?? [],
      enabled,
      staleTime: OPENING_HOURS_STALE_TIME,
    }
  )

  return { openingHours: data ?? [], isLoading, isError, refetch }
}

export function useExperienceOpeningHoursLabel() {
  return (windows: { from: string; to: string }[] | undefined) =>
    windows
      ?.map(window => `${window.from.slice(0, 5)} - ${window.to.slice(0, 5)} Uhr`)
      .join(' · ') ?? ''
}
